import { render, staticRenderFns } from "./ArthritisBodyModel.vue?vue&type=template&id=b460d6dc&scoped=true&"
import script from "./ArthritisBodyModel.vue?vue&type=script&lang=js&"
export * from "./ArthritisBodyModel.vue?vue&type=script&lang=js&"
import style0 from "./ArthritisBodyModel.vue?vue&type=style&index=0&id=b460d6dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b460d6dc",
  null
  
)

export default component.exports